import React from "react";
import PropTypes from "prop-types";
import SFTooltip from "../../../tooltip";
import SFTypography from "../../../typography";

const IconTypeTooltip = ({
  tooltip,
  children,
  disableTooltip,
  wrapChildrenWithSpan = false,
}) => {
  if (disableTooltip) {
    return <>{children}</>;
  }

  if (wrapChildrenWithSpan) {
    return (
      <SFTooltip
        content={<SFTypography variant="body2">{tooltip}</SFTypography>}
        variant="white"
      >
        <span style={{ pointerEvents: "all" }}>{children}</span>
      </SFTooltip>
    );
  }

  return (
    <SFTooltip
      content={<SFTypography variant="body2">{tooltip}</SFTypography>}
      variant="blue"
    >
      {children}
    </SFTooltip>
  );
};

IconTypeTooltip.propTypes = {
  // The text to display in the tooltip when hovering over the child component
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  // The child component to wrap with the tooltip
  children: PropTypes.element.isRequired,
  // Whether to disable the tooltip or not
  disableTooltip: PropTypes.bool,
  // Whether to wrap the children with a span element
  // (useful for disabled icons)
  wrapChildrenWithSpan: PropTypes.bool,
};

export default IconTypeTooltip;
